import styled from 'styled-components';


export const StyledContent = styled.div`
  padding-top: var(--cl-space-4);
`;

export const StyledList = styled.ul`
  font-family: var(--cl-font-family-mono);
  list-style-type: disc;
  padding-left: var(--cl-space-5);
  padding-top: var(--cl-space-2);
`;
